<!--
 * @Author: WangYuzhou
 * @Date: 2023-01-04 23:37:06
 * @LastEditors: WangYuzhou
 * @LastEditTime: 2024-06-11 11:24:32
 * @Description: TODO
-->
<template>
    <div class="section-div">
        <div class="tip"></div>
        <div class="section-title"> {{ title }}</div>
    </div>
</template>

<script>
export default {
  name: 'SectionTitle',
  props: {
    title: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="less" scoped>
.section-div{
    height: 50px;
    width: 100%;
    background: linear-gradient(to right, #083159, transparent);
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .tip{
    width: 4px;
    height: 25px;
    background-color: #3f96a5;
    margin-left: 20px;
  }

  .section-title{
    font-size: 20px;
    margin-left: 20px;
    font-weight: bold;
  }
</style>
